let usFebConsentCopyDisplayed = false

export const markUsFebConsentCopyDisplayed = (): void => {
  usFebConsentCopyDisplayed = true
}

export const clearUsFebConsentCopyDisplayed = (): void => {
  usFebConsentCopyDisplayed = false
}

export const consumeUsFebConsentCopyDisplayed = (): boolean => {
  const displayed = usFebConsentCopyDisplayed
  usFebConsentCopyDisplayed = false
  return displayed
}
